// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(inventory)/branch/_layout/inventory/medical-master/-components/component";
import { SearchParams } from "@/routes/(inventory)/branch/_layout/inventory/medical-master/-data/model";
import { getMedicalMasterItems } from "@/routes/(inventory)/branch/_layout/inventory/medical-master/-data/api";
import { MedicalMasterResponseSchema } from "@/routes/(inventory)/branch/_layout/inventory/medical-master/-data/type";
import { Loading } from "@/layouts/loading";
import { ListMedicalMasterResponse } from "@/gen/medical_master/list_medical_master_pb";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(inventory)/branch/_layout/inventory/medical-master/")({
    component: Component,
    validateSearch: SearchParams,
});